import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import type { UserRole } from "./types";

export function RoleGate({ role, children }: { role: UserRole; children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return <div className="page-loader" role="status"><span className="spinner-border" /> Ładowanie sesji…</div>;
  }
  if (auth.status !== "authenticated" || !auth.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (auth.user.role !== role) {
    return <Navigate to={auth.user.role === "SUPERADMIN" ? "/superadmin" : "/admin"} replace />;
  }
  return children;
}
